<template>
<div class="header_container">
    <nav class="navbar" role="navigation" aria-label="main navigation">
        <div class="navbar-brand">
            <div><router-link to="/" class="navbar-item">
            <img class="icon_image" v-lazy="'https://dream.ameneko.com/topImage-min.jpeg'" alt="アイコン">
                <span class="text_title" style="font-size:1em;font-weight:bold;color:#27546A;padding-left:5px;">夢占い辞典ゆめみん</span>
            </router-link>
            </div>
        </div>
    </nav>
</div>
</template>

<script>
export default {

}
</script>

<style scoped>
nav{
    max-width: 1080px;
    margin:auto;
}
a{
    padding:0;
}
.icon_image{
    border-radius: 10%;
}
</style>